import RichText from "@/components/RichText";
import { resolveButtonStyle } from "@/lib/ctaButtonStyle";
import CtaButtonBlocks, { ctaButtonBlocks } from "./CtaButtonBlocks";

// Valeurs par défaut identiques à theme_service.DEFAULT_PROPS["image_banner"]
// — voir HeroSection.jsx pour l'explication du repli.
const DEFAULTS = {
  heading: "Votre titre ici",
  subheading: "",
  cta_label: "En savoir plus",
  cta_url: "/boutique",
  image_url: "",
  overlay_opacity: "30",
};

export default function ImageBannerSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const overlay = Math.min(80, Math.max(0, Number(t.overlay_opacity) || 0)) / 100;
  const ctaStyle = resolveButtonStyle(t, "cta");
  const extraButtons = ctaButtonBlocks(blocks);

  return (
    <section className="relative">
      <div
        className="relative min-h-[420px] flex items-center justify-center text-center px-6 overflow-hidden"
        style={{
          backgroundImage: t.image_url ? `url(${t.image_url})` : undefined,
          backgroundColor: t.image_url ? undefined : "#0A0E17",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0" style={{ background: `rgba(10,14,23,${overlay})` }} />
        <div className="relative z-10 max-w-[640px] py-16">
          <RichText
            as="h2"
            className="font-display font-semibold text-[32px] md:text-[42px] leading-tight tracking-[-0.02em] text-white"
            html={t.heading}
          />
          {t.subheading && (
            <RichText
              as="p"
              preserveParagraphs
              className="text-[16px] text-white/85 mt-4 leading-relaxed [&_a]:underline"
              html={t.subheading}
            />
          )}
          {(t.cta_label || extraButtons.length > 0) && (
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              {t.cta_label && (
                <a
                  href={t.cta_url || "#"}
                  className={`inline-flex items-center gap-2 bg-white text-ink px-7 py-3.5 text-[15px] font-semibold hover:opacity-90 transition-opacity ${ctaStyle.className}`}
                  style={ctaStyle.style}
                  aria-label={!ctaStyle.showText ? t.cta_label : undefined}
                >
                  {ctaStyle.showIcon && ctaStyle.Icon && <ctaStyle.Icon className="h-4 w-4" />}
                  {ctaStyle.showText && t.cta_label}
                </a>
              )}
              <CtaButtonBlocks blocks={blocks} tone="dark" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
